import { defineStore } from "pinia";
import { computed, ref } from "vue";
import type {
    ProductSearchFilterConfigurationResponse
} from "@/api/modules/autoQ/productSearch/types.ts";
import {
    useProductSearchGlobalIsLoadingStore
} from "@/stores/productSearch/productSearchGlobalIsLoadingStore";
import { apiLibrary } from "@/api";

export const useProductSearchFilterConfigurationStore = defineStore("productSearchFilterConfigurationStore", () => {
    const configuration = ref<ProductSearchFilterConfigurationResponse>([]);

    const isLoadingStore = useProductSearchGlobalIsLoadingStore();

    const hasFilters = computed(() => !!configuration.value.length);

    const retrieve = async (businessUnitId?: number) => {
        await isLoadingStore.setLoadingState();

        try {
            const { data } = await apiLibrary.autoQ.productSearch.configuration(businessUnitId);

            configuration.value = data;
        } finally {
            await isLoadingStore.resetLoadingState();
        }
    };

    return { configuration, retrieve, hasFilters };
});